import { NgForOf, NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { type IsActiveMatchOptions, RouterModule, RouterLink } from '@angular/router';
import { IMegaMenuSettings } from '@ncg/data';
import { IconSpriteModule } from 'ng-svg-icon-sprite';

@Component({
    selector: 'ncg-alt-menu-icon-links',
    template: `
        <div class="mega-menu__item mega-menu__item--animate" *ngFor="let child of data.iconLinks; trackBy: trackByIndex">
            <ng-container *ngIf="child.link?.isExternal; else internalLink">
                <a
                    role="menuitem"
                    [href]="child.link?.url"
                    routerLinkActive="is-active"
                    [routerLinkActiveOptions]="activeMatchOptions"
                    [attr.target]="child.link?.target"
                    [attr.title]="child.linkHoverTitle"
                    [attr.aria-label]="child.linkHoverTitle"
                    rel="noopener">
                    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
                </a>
            </ng-container>
            <ng-template #internalLink>
                <a
                    role="menuitem"
                    [routerLink]="child.link?.url"
                    routerLinkActive="is-active"
                    [routerLinkActiveOptions]="activeMatchOptions"
                    [attr.target]="child.link?.target"
                    [attr.title]="child.linkHoverTitle"
                    [attr.aria-label]="child.linkHoverTitle">
                    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
                </a>
            </ng-template>
            <ng-template #linkContent>
                <svg-icon-sprite
                    [src]="child.icon || 'action-link'"
                    [viewBox]="'0 0 30 30'"
                    [width]="'30px'"
                    [height]="'30px'"
                    aria-hidden="true"></svg-icon-sprite>
                {{ child.link?.name }}
            </ng-template>
        </div>
    `,
    styleUrls: ['./alt-menu-icon-links.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterModule, RouterLink, IconSpriteModule, NgForOf, NgIf, NgTemplateOutlet],
})
export class AltMenuIconLinksComponent {
    @Input()
    public data: IMegaMenuSettings = {};

    readonly activeMatchOptions: IsActiveMatchOptions = {
        queryParams: 'ignored',
        matrixParams: 'exact',
        paths: 'exact',
        fragment: 'exact',
    };

    public trackByIndex(index: number) {
        return index;
    }
}
